import React, { Component } from "react";
import { Row, Col, Grid, Form, FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap';
import { map } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'

import { stagingItem } from './constants'
import QuoteItem from './QuoteItem'
import './Quote.css';

const RedAsterisk = () => {
  return (
    <span style={{color: "red"}}>&nbsp;&#42;</span>
  );
}

class Quote extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      gotError: false
    }
  }
  
  countTotal = () => {
    return map(stagingItem, (item, key) => item.price * (this.props.item[key] || 0))
      .reduce((a, b) => a + b)
  }

  handleSubmit = (e) => {
    e.preventDefault()
    let data = {
      type: "staging",
      name: this.name.value,
      phone: this.phone.value,
      email: this.email.value,
      address: this.address.value,
      item: this.props.item,
      total: this.countTotal()
    }
    this.props.firebase.push('requests', data)
    .then(() => {
      this.setState({submitted :true})
    })
    .catch(error => {
      this.setState({gotError: true})
      console.log(error)
    })
  }

  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12} className="quote-summary text-center">
            <h3> Get staging estimate and send the quote to us </h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="quote-title">
            <strong>Staging Estimate</strong>
            <ul>
              <li>Starting at $2000.</li>
              <li>No additional fee within 10 miles of warehouse, $100 for 10-30 miles, $200 for 30-50 miles.</li>
              <li>No additional fee for one story single family house; Additional fees may apply for condo and townhouse.</li>
            </ul>
          </Col>
        </Row>
        <hr />
        {
          map(stagingItem, (item, key) => {
            return [
              <QuoteItem key='item'
                         name={key} 
                         image={item.image} 
                         description={item.description} 
                         price={item.price} 
                         count={this.props.item[key] || 0 }/>,
              <hr key='divider' />
            ]
          })
        }
        <Row className="quote-total">
          <Col xs={4} />
          <Col xs={8}>
            <Col xs={0} md={6} />
            <Col xs={6} md={3}>
              <strong>Total</strong>
            </Col>
            <Col xs={4} md={3}>
              ${Math.max(this.countTotal(), 2000)}
            </Col>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="quote-title">
            Staging Project Information
          </Col>
        </Row>
        <Row>
          <Form onSubmit={this.handleSubmit}>
            <Col xs={12} md={3} className="quote-form">
              <FormGroup controlId="formName">
                <ControlLabel>Name</ControlLabel>
                <RedAsterisk/>
                <FormControl type="name" placeholder="Enter Your Name" inputRef={ref => { this.name = ref; }} required/>
              </FormGroup>
            </Col>
            <Col xs={12} md={3} className="quote-form">
              <FormGroup controlId="formPhone">
                <ControlLabel>Phone</ControlLabel>
                <RedAsterisk/>
                <FormControl type="phone" placeholder="Phone Number" inputRef={ref => { this.phone = ref; }} required/>
              </FormGroup>
            </Col>
            <Col xs={12} md={3} className="quote-form">
              <FormGroup controlId="formEmail">
                <ControlLabel>Email</ControlLabel>
                <RedAsterisk/>
                <FormControl type="email" placeholder="Email" inputRef={ref => { this.email = ref; }} required/>
              </FormGroup>
            </Col>
            <Col xs={12} md={3} className="quote-form">
              <FormGroup controlId="formAddress">
                <ControlLabel>Staging Address</ControlLabel>
                <RedAsterisk/>
                <FormControl type="address" placeholder="Staging Address" inputRef={ref => { this.address = ref; }} required/>
              </FormGroup>
            </Col>
            <Col xs={12}>
              <FormGroup>
                <Button bsStyle="primary" type="submit">Submit</Button>
              </FormGroup>
            </Col>
          </Form>
        </Row>
        {
          this.state.submitted &&
          <Col xs={12} md={8} className="text-center">
            <h4>You request is submitted</h4>
            <h4>We will get back to you in 24 hours.</h4>
          </Col>
        }
      </Grid>
    );
  }
}

export default compose(
  firebaseConnect(['requests']),
  connect(
    ({ item }) => ({ item })
  )
)(Quote)


// WEBPACK FOOTER //
// ./src/Quote.js